import { render } from "./ModalProcessOrder.vue?vue&type=template&id=0ec146aa&scoped=true"
import script from "./ModalProcessOrder.vue?vue&type=script&lang=js"
export * from "./ModalProcessOrder.vue?vue&type=script&lang=js"

import "./ModalProcessOrder.vue?vue&type=style&index=0&id=0ec146aa&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec146aa"]])

export default __exports__